import { IRowAccessObject, RowAccessControlObject } from './types'

export class RowAccessControlSchema {
  public static getObjects(): IRowAccessObject[] {
    return [
      { object: RowAccessControlObject.CaseType },
      { object: RowAccessControlObject.Form },
      { object: RowAccessControlObject.Provider },
    ]
  }

  public static getAllDefinitionNames(): string[] {
    return this.getObjects().map((object) => object.object)
  }
}
